import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ImageEditorModule } from '../dave-dms-module/dave-dms/image-editor/image-editor.module';
import { PdfEditorLegacyModule } from '../dave-dms-module/dave-dms/pdf-editor-legacy/pdf-editor-legacy.module';
import { PdfEditorComponent } from '../dave-dms-module/dave-dms/pdf-editor/pdf-editor.component';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { FullscreenDialogComponent } from './components/fullscreen-dialog.component';

@NgModule({
    declarations: [FullscreenDialogComponent],
    imports: [CommonModule, FontAwesomeModule, ImageEditorModule, PdfEditorLegacyModule, MatButtonModule, MatTooltipModule, AppButtonModule, PdfEditorComponent],
    exports: [FullscreenDialogComponent],
})
export class DaveFullscreenDialogModule {}
